"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconCheckboxEmpty = _interopRequireDefault(require("../../icons/icon-checkbox-empty.svg"));

var _iconCheckboxChecked = _interopRequireDefault(require("../../icons/icon-checkbox-checked.svg"));

var _isEnterOrSpace = _interopRequireDefault(require("../../helpers/isEnterOrSpace"));

var _CustomReactMarkdown = _interopRequireDefault(require("../MarkdownRenderers/CustomReactMarkdown"));

var _MarkdownExternalLinkRenderer = _interopRequireDefault(require("../MarkdownRenderers/MarkdownExternalLinkRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Checkbox = function CheckboxComponent(_ref) {
  var checked = _ref.checked,
      _onClick = _ref.onClick,
      label = _ref.label,
      markdown = _ref.markdown,
      id = _ref.id,
      name = _ref.name;

  var Icon = function Icon(_ref2) {
    var checked = _ref2.checked;

    if (checked) {
      return /*#__PURE__*/_react["default"].createElement(_iconCheckboxChecked["default"], {
        className: "mp-checkbox__icon"
      });
    }

    return /*#__PURE__*/_react["default"].createElement(_iconCheckboxEmpty["default"], {
      className: "mp-checkbox__icon icon_empty"
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mp-checkbox"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    id: id,
    className: "mp-checkbox__input",
    type: "checkbox",
    checked: checked,
    name: name,
    onChange: function onChange() {},
    tabIndex: -1
  }), /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    className: "mp-checkbox__container",
    onClick: function onClick() {
      return _onClick(!checked);
    },
    onKeyPress: function onKeyPress(event) {
      return (0, _isEnterOrSpace["default"])(event) && _onClick(!checked);
    },
    tabIndex: 0
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mp-checkbox__icon-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    checked: checked
  })), label && /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id,
    className: "mp-checkbox__label"
  }, label), markdown && /*#__PURE__*/_react["default"].createElement("span", {
    className: "mp-checkbox__markdown"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mp-checkbox__hidden-label"
  }, markdown), /*#__PURE__*/_react["default"].createElement(_CustomReactMarkdown["default"], {
    source: markdown,
    renderers: {
      paragraph: 'span',
      link: _MarkdownExternalLinkRenderer["default"]
    }
  }))));
};

Checkbox.propTypes = {
  checked: _propTypes["default"].bool.isRequired,
  onClick: _propTypes["default"].func.isRequired,
  label: _propTypes["default"].string,
  markdown: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string
};
Checkbox.defaultProps = {
  label: undefined,
  markdown: undefined,
  name: ''
};
var _default = Checkbox;
exports["default"] = _default;